<template>
    <div class="grid justify-content-center mt-3">
        <div class="col-12 md:col-4 lg:col-3" >
            <Listbox 
                v-if="dataListbox.length"
                v-model="dataArrId" 
                :options="dataListbox" 
                dataKey="ActuacionPersonaFisicaID" 
                optionValue="ActuacionPersonaFisicaID"
                optionLabel="name" 
                ref="listBox" 
                class="shadow-4 border-none"
            >
                <template #option="slotProps">
                    <div class="flex justify-content-between">
                        <span class="mt-2" v-if="slotProps.option.Nombre">{{ slotProps.option.Apellido + ', ' + slotProps.option.Nombre }}</span>
                        <span class="mt-2" v-else>{{ slotProps.option.Apellido }}</span>
                    </div>
                </template>
            </Listbox>
        </div>
        <div v-if="!dataListbox.length" class="col-12 px-5 shadow-4 text-center" >
            <label class="text-xl">No hay personas {{ isAfectados ? 'Afectadas' : 'Vinculadas' }} registradas</label>
        </div>
        <div v-else class="col-8 px-5 shadow-4 text-center" >
            <label v-if="!selectedPersona && dataListbox.length" class="text-xl">Seleccione un {{ isAfectados ? 'Afectado' : 'Vinculado' }} para visualizar el detalle del mismo</label>
            <PersonaForm v-else :persona="selectedPersona" :acusado="false" />
        </div>
    </div>


</template>

<script>
import Listbox from "primevue/listbox";
import PersonaForm from './PersonaForm.vue'
import { mapGetters, mapState } from "vuex";

export default {
    name: "DenunciantesView",
    components: {
        PersonaForm,
        Listbox,
    },
    props: {
        formType: String,
        actuacionType: String,
        isAfectados: Boolean
    },
    data() {
        return {
            arrId: this.aid || null,
            selectedPersona: null,
        };
    },
    mounted() {
        if (this.arrId && this.isAfectados) {
            this.selectedPersona = this.getDenuncianteByPersonaFisicaID(this.arrId);
        }
        if (this.arrId) {
            this.selectedPersona = this.getAcusadosByPersonaFisicaID(this.arrId)
        }
    },
    computed: {
        ...mapGetters("sumario/denunciante", [
            "getDenuncianteByPersonaFisicaID",
        ]),
        ...mapGetters("sumario/acusados", [
            "getAcusadosByPersonaFisicaID"
        ]),
        ...mapState({
            denunciante: (state) => state.sumario.denunciante,
            acusados: (state) => state.sumario.acusados,
            viewData: (state) => state.sumarioViews,
        }),

        dataArrId: {
            get() {
                return this.arrId;
            },
            set(value) {
                this.arrId = value;
            },
        },

        dataListbox(){
            return this.isAfectados ? this.denunciante.list : this.acusados.list 
        }
    },
    watch: {
        arrId: function (newValue) {
            if(this.isAfectados){
                this.selectedPersona = this.getDenuncianteByPersonaFisicaID(newValue)
            }else{
                this.selectedPersona = this.getAcusadosByPersonaFisicaID(newValue)
            }
        },
    },
    methods:{
    }
};
</script>
<style scoped>
.card {
    background: #ffffff;
    padding: 2rem;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
        0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
        0 1px 3px 0 rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    margin-bottom: 1rem;
}
</style>